import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-03/lesson-08/task-01";

const task: Slide = {
  titleHtml:
    "Image sources have been calculated for one receiver and one soud source. Now the</br>receiver changes its position. Which calculation processes needs to be repeated?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
